"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSocketBaseUrl = exports.AppBaseUrl = exports.ApiBaseUrl = exports.APP_URL_LOCAL_SOCKET = exports.APP_URL_DEV_SOCKET = exports.APP_URL_PROD_SOCKET = exports.APP_URL_DEV = exports.APP_URL_LOCAL = exports.Env = exports.currentEnv = void 0;
exports.currentEnv = "prod";
const env = exports.currentEnv;
exports.Env = env;
const API_LOCAL_URL = `http://127.0.0.1:8000/api/v1/app/`;
const API_DEV_URL = `https://sunuautoroute.volkeno.com/api/v1/app/`;
// const API_PROD_URL = "https://api-v2.eiffageconcessionssenegal.sn/api/v1/app/";
const API_PROD_URL = "https://api-v2.autoroutedelavenir.sn/api/v1/app/";
exports.APP_URL_LOCAL = "http://127.0.0.1:8000";
exports.APP_URL_DEV = "https://sunuautoroute.volkeno.com";
exports.APP_URL_PROD_SOCKET = "https://api-v2.eiffageconcessionssenegal.sn";
exports.APP_URL_DEV_SOCKET = "https://sunuautoroute.volkeno.com";
exports.APP_URL_LOCAL_SOCKET = "http://localhost";
const APP_URL_PROD = "https://api-v2.autoroutedelavenir.sn";
function ProcessApiUrl() {
    // const lang = useLang();
    if (env === "local")
        return API_LOCAL_URL;
    if (env === "prod")
        return API_PROD_URL;
    return API_DEV_URL;
}
function processAppUrl() {
    if (env === "local")
        return exports.APP_URL_LOCAL;
    if (env === "prod")
        return APP_URL_PROD;
    return exports.APP_URL_DEV;
}
function processAppSocketUrl() {
    if (env === "local")
        return exports.APP_URL_LOCAL_SOCKET;
    if (env === "prod")
        return exports.APP_URL_PROD_SOCKET;
    return exports.APP_URL_DEV_SOCKET;
}
exports.ApiBaseUrl = ProcessApiUrl();
exports.AppBaseUrl = processAppUrl();
exports.AppSocketBaseUrl = processAppSocketUrl();
